import ColorfulNotice from './colorful-notice';
export default ColorfulNotice;
